<template>
    <li class="nav-item">
        <a :class="['nav-link', { active: active }]" data-toggle="tab" :href="href" ref="a">
            <slot></slot>
        </a>
    </li>
</template>
<script>
export default {
    name: "NavTabItem",
    props: {
        href: {
            type: String
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        click() {
            this.$refs.a.click()
        }
    }
}
</script>